import { FC } from "react";

interface GoogleSVGProps {
    width?: number;
    height?: number;
}

const GoogleSVG: FC<GoogleSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
        >
            <g clip-path="url(#clip0_363_4243)">
                <path
                    d="M17.7854 9.16862C17.7854 8.43117 17.7255 7.89303 17.596 7.33496H9.17505V10.6634H14.118C14.0184 11.4906 13.4802 12.7363 12.2843 13.5734L12.2675 13.6848L14.9301 15.7475L15.1146 15.7659C16.8087 14.2013 17.7854 11.8992 17.7854 9.16862Z"
                    fill="#4285F4"
                />
                <path
                    d="M9.175 17.9384C11.5966 17.9384 13.6296 17.1411 15.1145 15.7659L12.2843 13.5734C11.5269 14.1015 10.5104 14.4703 9.175 14.4703C6.80319 14.4703 4.79015 12.9057 4.07255 10.7432L3.96737 10.7521L1.1988 12.8947L1.1626 12.9954C2.6375 15.9252 5.66706 17.9384 9.175 17.9384Z"
                    fill="#34A853"
                />
                <path
                    d="M4.07269 10.7431C3.88335 10.185 3.77377 9.58704 3.77377 8.9692C3.77377 8.35129 3.88335 7.75338 4.06273 7.19531L4.05771 7.07645L1.25445 4.89941L1.16273 4.94304C0.554856 6.15886 0.206055 7.52419 0.206055 8.9692C0.206055 10.4142 0.554856 11.7795 1.16273 12.9953L4.07269 10.7431Z"
                    fill="#FBBC05"
                />
                <path
                    d="M9.175 3.46802C10.8592 3.46802 11.9952 4.19551 12.643 4.80346L15.1743 2.33196C13.6197 0.886947 11.5966 0 9.175 0C5.66706 0 2.6375 2.01305 1.1626 4.94292L4.06259 7.19519C4.79015 5.03265 6.80319 3.46802 9.175 3.46802Z"
                    fill="#EB4335"
                />
            </g>
            <defs>
                <clipPath id="clip0_363_4243">
                    <rect
                        width="17.5896"
                        height="18"
                        fill="white"
                        transform="translate(0.205078)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default GoogleSVG;
